/** A byte count a person can read: "0 Bytes", "12.4 KB", "3.07 MB". */
export const formatFileSize = (bytes: number): string => {
  if (!bytes) return '0 Bytes';
  const units = ['Bytes', 'KB', 'MB', 'GB'];
  const unit = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, unit);
  return `${parseFloat(value.toFixed(2))} ${units[unit]}`;
};

export default formatFileSize;
